import WorkLogForm from "../workLogForm";
//--------------------------------------------------------------------------------------------
export default function ElectricPotholeForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "EP No.", example: "1,2,3,4,etc.", type: "text", required: true, docNum: true}, 
        {title: "Cancel", type:"radio", default: "No", required: true}, 
        {title: "Coordniates", type: "latlng", parentNo: "Cancel"}, 
        {title: "Utility Type", example: "Gas, Electric etc.", type:"text", parentNo: "Cancel", required: true}, 
        {title: "Depth", type:"number", parentNo: "Cancel", required: true}, 
        {title: "Swing Tie 1", type:"text", parentNo: "Cancel", required: true}, 
        {title: "Swing Tie 2", type:"text", parentNo: "Cancel", required: true}, 
        {title: "Swing Tie 3", type:"text", parentNo: "Cancel", required: true}, 
        {title: "Notes", type: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            picsLimit = {5}
            items = {items}
            {...rest}
        />
    )    
}